import React from 'react';
import { HeroSection } from '../components/sections/HeroSection';
import { AuthorityNumbersSection } from '../components/sections/AuthorityNumbersSection';
import { ProblemSection } from '../components/sections/ProblemSection';
import { SolutionSection } from '../components/sections/SolutionSection';
import { BenefitsSection } from '../components/sections/BenefitsSection';
import { BonusSection } from '../components/sections/BonusSection';
import { ScarcitySection } from '../components/sections/ScarcitySection';
import { ValueAnchorSection } from '../components/sections/ValueAnchorSection';
import { PricingSection } from '../components/sections/PricingSection';
import { TestimonialSection } from '../components/sections/TestimonialSection';
import { GuaranteeSection } from '../components/sections/GuaranteeSection';
import { FAQSection } from '../components/sections/FAQSection';
import { ClosingSection } from '../components/sections/ClosingSection';
import { FooterSection } from '../components/sections/FooterSection';
import { SocialProofPopup } from '../components/ui/SocialProofPopup';
export function LandingPage() {
  return <main className="min-h-screen bg-background-dark text-gray-300 font-body selection:bg-primary/30 selection:text-white" data-id="element-410">
      <HeroSection data-id="element-411" />
      <ProblemSection data-id="element-412" />
      <AuthorityNumbersSection data-id="element-413" />
      <SolutionSection data-id="element-414" />
      <BenefitsSection data-id="element-415" />
      <BonusSection data-id="element-416" />
      <ScarcitySection data-id="element-417" />
      <ValueAnchorSection data-id="element-418" />
      <PricingSection data-id="element-419" />
      <TestimonialSection data-id="element-420" />
      <GuaranteeSection data-id="element-421" />
      <FAQSection data-id="element-422" />
      <ClosingSection data-id="element-423" />
      <FooterSection data-id="element-424" />
      <SocialProofPopup data-id="element-425" />
    </main>;
}